import moment from 'moment-timezone';

export default class GamePackageSender {

    constructor(gameAPI) {
        this.gameAPI = gameAPI;
        this.game = gameAPI.game;
        this.userId = this.game.userId;
        this.sendPackagedMessage = this.game.authenticator.sendPackagedMessage;
        this.packageId = 0;
    }

    sendPackage = (typeName, packageValue) => {
        const message = this._makePackage(typeName, packageValue);
        this.sendPackagedMessage(message);
    };

    _makePackage = (typeName, packageValue) => {
        ++this.packageId;
        let message = {};
        message.datetime = moment();
        message.user = this.userId;
        if (this.game.gameData && this.game.gameData.id) {
            message.game = this.game.gameData.id;
        }
        message.type = typeName;
        message.package = packageValue;

        return JSON.stringify(message);
    };
}
